export default __webpack_public_path__ + "static/livechat-3c66bfb95f538fae42d2a6afb8e220f1.png";